import React, { useEffect, useMemo } from 'react'
import { Card, Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { appUrl, apiResource } from '../../utils'
import ReactTableBootstrap from 'react-table-bootstrap'
import LoadingIcon from '../../components/loading/LoadingIcon'
import OficinaTabs from '../../components/oficina-tabs/OficinaTabs'
import { useGet } from '../../hooks/process-data'
/* import { doRequestGet } from '../../api' */

export default function CompraProductosView() {
  const history = useHistory()
  const { sessionValidated, isCustomer, key_customer } = useSelector(
    state => state.session
  )

  const execute = !!(sessionValidated && isCustomer && key_customer)

  const { rows, isProcessing, setReload } = useGet({
    url: '/product/orders',
    execute
  })

  useEffect(() => {
    if (!sessionValidated || !isCustomer) {
      const redirect = encodeURIComponent(appUrl({ url: '/compra-productos' }))
      history.push(
        appUrl({ url: '/cuenta/login?redirect=' + redirect })
      )
    } else {
      setReload(true)
    }
  }, [sessionValidated, isCustomer, history, setReload])

  /* const handleRegeneratePdf = async (idProductOrder) => {
    try {
      const res = await doRequestGet({
        url: `/product/order/${idProductOrder}/regenerate-pdf`
      })
      if (res.response === 'success') {
        setReload(true)
      }
    } catch (e) {
      // ignore
    }
  } */

  const table = useMemo(() => {
    const head = [
      {
        name: 'date_pay',
        text: 'Fecha de compra',
        align: 'center'
      },
      {
        name: 'method_pay',
        text: 'Método de pago',
        align: 'center',
        render: r => (
          <span className="badge badge-pill bg-info text-uppercase">
            {r.method_pay || '—'}
          </span>
        )
      },
      {
        name: 'cargo_por_orden',
        text: 'Cargo por orden (MXN)',
        align: 'center',
        render: r => {
          const v = parseFloat(r.cargo_por_orden || 0)
          return v.toFixed(2)
        }
      },
      {
        name: 'total_amount',
        text: 'Total (MXN)',
        align: 'center',
        render: r => {
          const v = parseFloat(r.total_amount || 0)
          return <strong>{v.toFixed(2)}</strong>
        }
      },
      {
        name: 'actions',
        text: <i className="fa fa-file-pdf" />,
        align: 'center',
        render: r => {
          if (r.pdf_url) {
            const href = apiResource({ url: r.pdf_url })
            return (
              <a href={href} target="_blank" rel="noreferrer">
                <Button variant="danger" size="sm">
                  <i className="fa fa-file-pdf me-1 text-white" />
                  <span className="text-white">Descargar PDF</span>
                </Button>
              </a>
            )
          }
          /* return (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleRegeneratePdf(r.id_product_order)}
            >
              Generar PDF
            </Button>
          ) */
         return <></>
        }
      }
    ]

    return (
      <ReactTableBootstrap
        head={[head]}
        rows={rows}
        isProcessing={isProcessing}
        pageLength={10}
        orderDirection="desc"
        columnOrder="date_pay"
      />
    )
  }, [rows, isProcessing])

  const hasOrders = rows && rows.length > 0

  return (
    <>
      <div className="container py-4 py-lg-5">
        <OficinaTabs />
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-11 col-12">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
              <div>
                <h1 className="h4 mb-1">Compra de Productos</h1>
                <p className="text-muted mb-0">
                  Historial de tus órdenes de merchandising pagadas. Descarga el comprobante en PDF.
                </p>
              </div>
            </div>

            <Card className="shadow-sm border-0">
              <Card.Body>
                {isProcessing && (
                  <div className="d-flex justify-content-center py-4">
                    <LoadingIcon />
                  </div>
                )}

                {!isProcessing && !hasOrders && (
                  <div className="text-center py-5">
                    <i className="fa fa-shopping-bag fa-3x text-muted mb-3" />
                    <h2 className="h5 mb-2">No tienes órdenes de productos</h2>
                    <p className="text-muted mb-4">
                      Cuando compres merchandising y el pago sea aprobado, tus órdenes aparecerán aquí.
                    </p>
                    <Button
                      variant="primary"
                      onClick={() => history.push(appUrl({ url: '/productos' }))}
                    >
                      Ver productos
                    </Button>
                  </div>
                )}

                {hasOrders && <>{table}</>}
              </Card.Body>
            </Card>
          </div>
        </div>

        {isProcessing && hasOrders && (
          <div className="d-flex justify-content-center mt-3">
            <LoadingIcon />
          </div>
        )}
      </div>
    </>
  )
}
